// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UsersContent_container__e5W7X {
  padding: 2rem;
  background-color: #121214;
  color: #fff;
  min-height: 100vh;
}

.UsersContent_header__Nydro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.UsersContent_title__R-tz4 {
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0;
}

.UsersContent_subtitle__79goL {
  font-size: 0.875rem;
  color: #a1a1aa;
  margin: 0.25rem 0 0 0;
  flex-basis: 100%;
}

.UsersContent_addButton__OdV9R {
  background-color: #dc2626;
  color: white;
  border: none;
  padding: 0.625rem 1.25rem;
  border-radius: 0.375rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.UsersContent_addButton__OdV9R:hover {
  background-color: #b91c1c;
}

.UsersContent_statsContainer__nm2J1 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.UsersContent_statCard__U6bS- {
  background-color: #18181b;
  border-radius: 0.5rem;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.UsersContent_statIcon__1MMO7 {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
}

.UsersContent_statIcon__1MMO7 svg {
  width: 1.5rem;
  height: 1.5rem;
}

.UsersContent_totalIcon__IUZ2\\+ {
  color: #ef4444;
  background-color: rgba(239, 68, 68, 0.1);
}

.UsersContent_activeIcon__Po2oP {
  color: #10b981;
  background-color: rgba(16, 185, 129, 0.1);
}

.UsersContent_suspendedIcon__\\+MC3o {
  color: #f59e0b;
  background-color: rgba(245, 158, 11, 0.1);
}

.UsersContent_verifiedIcon__PRM8L {
  color: #3b82f6;
  background-color: rgba(59, 130, 246, 0.1);
}

.UsersContent_statInfo__GUWui {
  display: flex;
  flex-direction: column;
}

.UsersContent_statLabel__PV9zJ {
  font-size: 0.875rem;
  color: #a1a1aa;
  margin-bottom: 0.25rem;
}

.UsersContent_statValue__zYc5w {
  font-size: 1.5rem;
  font-weight: 600;
}

.UsersContent_tableControls__ChlGL {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.UsersContent_searchBar__DZN71 {
  flex: 1 1;
  min-width: 200px;
}

.UsersContent_searchInput__00eY5 {
  width: 98%;
  padding: 0.625rem;
  border-radius: 0.375rem;
  border: 1px solid #3f3f46;
  background-color: #18181b;
  color: #fff;
  font-size: 0.875rem;
}

.UsersContent_filters__bgOVw {
  display: flex;
  gap: 0.75rem;
}

.UsersContent_roleFilter__fEE6g,
.UsersContent_actionSelect__J4xuS {
  padding: 0.625rem;
  border-radius: 0.375rem;
  border: 1px solid #3f3f46;
  background-color: #18181b;
  color: #fff;
  font-size: 0.875rem;
  min-width: 120px;
}

.UsersContent_tableWrapper__EXvZm {
  background-color: #18181b;
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.UsersContent_table__wHvCQ {
  width: 100%;
  border-collapse: collapse;
}

.UsersContent_table__wHvCQ th,
.UsersContent_table__wHvCQ td {
  padding: 1rem;
  text-align: left;
}

.UsersContent_table__wHvCQ th {
  background-color: #27272a;
  color: #a1a1aa;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.UsersContent_table__wHvCQ td {
  border-bottom: 1px solid #3f3f46;
}

.UsersContent_table__wHvCQ tr:last-child td {
  border-bottom: none;
}

.UsersContent_userColumn__oe0Uu {
  min-width: 250px;
}

.UsersContent_userCell__1CP-H {
  white-space: nowrap;
}

.UsersContent_userInfo__0nb8v {
  display: flex;
  align-items: center;
}

.UsersContent_avatar__RmcjJ {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  overflow: hidden;
  background-color: #3f3f46;
  margin-right: 0.75rem;
}

.UsersContent_userAvatar__tSgNH {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.UsersContent_userDetails__64Yb- {
  display: flex;
  flex-direction: column;
}

.UsersContent_userName__taxSa {
  font-weight: 500;
}

.UsersContent_userEmail__52vzd {
  font-size: 0.875rem;
  color: #a1a1aa;
}

.UsersContent_roleTag__q3hL7,
.UsersContent_statusTag__4B72W {
  display: inline-block;
  padding: 0.25rem 0.625rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
}

.UsersContent_roleAdmin__\\+bc0c {
  background-color: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.UsersContent_roleEditor__L0CaP {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.UsersContent_roleUser__LdHz7 {
  background-color: rgba(107, 114, 128, 0.2);
  color: #9ca3af;
}

.UsersContent_statusActive__3dFB1 {
  background-color: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.UsersContent_statusSuspended__RowS6 {
  background-color: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.UsersContent_statusPending__u9EID {
  background-color: rgba(245, 158, 11, 0.2);
  color: #f59e0b;
}

.UsersContent_actions__HH4md {
  gap: 0.5rem;
}

.UsersContent_editButton__4wsj-,
.UsersContent_deleteButton__nho3\\+ {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  border: none;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.UsersContent_editButton__4wsj- {
  background-color: transparent;
  color: #a1a1aa;
  border: 1px solid #3f3f46;
}
.UsersContent_editButton__4wsj-:hover {
  background-color: #3f3f46;
  color: #fff;
}
.UsersContent_deleteButton__nho3\\+ {
  background-color: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}
.UsersContent_deleteButton__nho3\\+:hover {
  background-color: rgba(239, 68, 68, 0.2);
}
.UsersContent_pagination__qzX0G {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  flex-wrap: wrap;
  gap: 1rem;
}
.UsersContent_pageInfo__\\+Jhcl {
  font-size: 0.875rem;
  color: #a1a1aa;
}
.UsersContent_pageControls__oILFr {
  display: flex;
  gap: 2rem;
}
.UsersContent_pageButton__YFsjE {
  padding: 0.5rem 0.75rem;
  background-color: #27272a;
  border: none;
  border-radius: 0.25rem;
  color: #a1a1aa;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.UsersContent_pageButton__YFsjE:hover:not(:disabled) {
  background-color: #3f3f46;
  color: #fff;
}
.UsersContent_pageButton__YFsjE:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.UsersContent_activePage__Ig9dd {
  background-color: #dc2626;
  color: white;
}
.UsersContent_activePage__Ig9dd:hover {
  background-color: #b91c1c;
}
.UsersContent_ellipsis__B6XRc {
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  color: #a1a1aa;
}
.UsersContent_error__oFPYV {
  background-color: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}
.UsersContent_container__e5W7X {
  padding: 1rem;
}

.UsersContent_header__Nydro {
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
}

.UsersContent_statsContainer__nm2J1 {
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.75rem;
}

.UsersContent_statCard__U6bS- {
  padding: 1rem;
}

.UsersContent_statIcon__1MMO7 {
  width: 2.5rem;
  height: 2.5rem;
}

.UsersContent_tableControls__ChlGL {
  flex-direction: column;
  gap: 0.75rem;
}

.UsersContent_searchBar__DZN71, .UsersContent_filters__bgOVw {
  width: 100%;
}

.UsersContent_tableWrapper__EXvZm {
  overflow-x: auto;
}

.UsersContent_table__wHvCQ {
  min-width: 650px;
}

.UsersContent_avatar__RmcjJ {
  width: 2rem;
  height: 2rem;
}

.UsersContent_userName__taxSa, .UsersContent_userEmail__52vzd {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}

.UsersContent_pagination__qzX0G {
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

/* Tablet and desktop adjustments */
@media (min-width: 768px) {
  .UsersContent_container__e5W7X {
    padding: 2rem;
  }
  
  .UsersContent_header__Nydro {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  
  .UsersContent_tableControls__ChlGL {
    flex-direction: row;
    justify-content: space-between;
  }
  
  .UsersContent_searchBar__DZN71 {
    flex: 1 1;
    max-width: 60%;
  }
  
  .UsersContent_filters__bgOVw {
    width: auto;
    display: flex;
    gap: 0.75rem;
  }
  
  .UsersContent_pagination__qzX0G {
    flex-direction: row;
    justify-content: space-between;
  }
  
  .UsersContent_userName__taxSa, .UsersContent_userEmail__52vzd {
    max-width: 200px;
  }
}

.UsersContent_modalWrapper__r2Qdg{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.UsersContent_modalContent__7OYlX {
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(255, 51, 51, 0.5);
  position: relative;
  
}
.UsersContent_closeButton__Emwog {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/UsersContent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;;AAEpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":[".container {\n  padding: 2rem;\n  background-color: #121214;\n  color: #fff;\n  min-height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.title {\n  font-size: 1.75rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.subtitle {\n  font-size: 0.875rem;\n  color: #a1a1aa;\n  margin: 0.25rem 0 0 0;\n  flex-basis: 100%;\n}\n\n.addButton {\n  background-color: #dc2626;\n  color: white;\n  border: none;\n  padding: 0.625rem 1.25rem;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.addButton:hover {\n  background-color: #b91c1c;\n}\n\n.statsContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.statCard {\n  background-color: #18181b;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.statIcon {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 1rem;\n}\n\n.statIcon svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.totalIcon {\n  color: #ef4444;\n  background-color: rgba(239, 68, 68, 0.1);\n}\n\n.activeIcon {\n  color: #10b981;\n  background-color: rgba(16, 185, 129, 0.1);\n}\n\n.suspendedIcon {\n  color: #f59e0b;\n  background-color: rgba(245, 158, 11, 0.1);\n}\n\n.verifiedIcon {\n  color: #3b82f6;\n  background-color: rgba(59, 130, 246, 0.1);\n}\n\n.statInfo {\n  display: flex;\n  flex-direction: column;\n}\n\n.statLabel {\n  font-size: 0.875rem;\n  color: #a1a1aa;\n  margin-bottom: 0.25rem;\n}\n\n.statValue {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.tableControls {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.searchBar {\n  flex: 1;\n  min-width: 200px;\n}\n\n.searchInput {\n  width: 98%;\n  padding: 0.625rem;\n  border-radius: 0.375rem;\n  border: 1px solid #3f3f46;\n  background-color: #18181b;\n  color: #fff;\n  font-size: 0.875rem;\n}\n\n.filters {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.roleFilter,\n.actionSelect {\n  padding: 0.625rem;\n  border-radius: 0.375rem;\n  border: 1px solid #3f3f46;\n  background-color: #18181b;\n  color: #fff;\n  font-size: 0.875rem;\n  min-width: 120px;\n}\n\n.tableWrapper {\n  background-color: #18181b;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th,\n.table td {\n  padding: 1rem;\n  text-align: left;\n}\n\n.table th {\n  background-color: #27272a;\n  color: #a1a1aa;\n  font-weight: 500;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.table td {\n  border-bottom: 1px solid #3f3f46;\n}\n\n.table tr:last-child td {\n  border-bottom: none;\n}\n\n.userColumn {\n  min-width: 250px;\n}\n\n.userCell {\n  white-space: nowrap;\n}\n\n.userInfo {\n  display: flex;\n  align-items: center;\n}\n\n.avatar {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: #3f3f46;\n  margin-right: 0.75rem;\n}\n\n.userAvatar {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.userDetails {\n  display: flex;\n  flex-direction: column;\n}\n\n.userName {\n  font-weight: 500;\n}\n\n.userEmail {\n  font-size: 0.875rem;\n  color: #a1a1aa;\n}\n\n.roleTag,\n.statusTag {\n  display: inline-block;\n  padding: 0.25rem 0.625rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.roleAdmin {\n  background-color: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.roleEditor {\n  background-color: rgba(59, 130, 246, 0.2);\n  color: #3b82f6;\n}\n\n.roleUser {\n  background-color: rgba(107, 114, 128, 0.2);\n  color: #9ca3af;\n}\n\n.statusActive {\n  background-color: rgba(16, 185, 129, 0.2);\n  color: #10b981;\n}\n\n.statusSuspended {\n  background-color: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.statusPending {\n  background-color: rgba(245, 158, 11, 0.2);\n  color: #f59e0b;\n}\n\n.actions {\n  gap: 0.5rem;\n}\n\n.editButton,\n.deleteButton {\n  padding: 0.375rem 0.75rem;\n  border-radius: 0.25rem;\n  border: none;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n.editButton {\n  background-color: transparent;\n  color: #a1a1aa;\n  border: 1px solid #3f3f46;\n}\n.editButton:hover {\n  background-color: #3f3f46;\n  color: #fff;\n}\n.deleteButton {\n  background-color: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n.deleteButton:hover {\n  background-color: rgba(239, 68, 68, 0.2);\n}\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 0;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n.pageInfo {\n  font-size: 0.875rem;\n  color: #a1a1aa;\n}\n.pageControls {\n  display: flex;\n  gap: 2rem;\n}\n.pageButton {\n  padding: 0.5rem 0.75rem;\n  background-color: #27272a;\n  border: none;\n  border-radius: 0.25rem;\n  color: #a1a1aa;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n.pageButton:hover:not(:disabled) {\n  background-color: #3f3f46;\n  color: #fff;\n}\n.pageButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.activePage {\n  background-color: #dc2626;\n  color: white;\n}\n.activePage:hover {\n  background-color: #b91c1c;\n}\n.ellipsis {\n  display: flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  color: #a1a1aa;\n}\n.error {\n  background-color: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n}\n.container {\n  padding: 1rem;\n}\n\n.header {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.statsContainer {\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 0.75rem;\n}\n\n.statCard {\n  padding: 1rem;\n}\n\n.statIcon {\n  width: 2.5rem;\n  height: 2.5rem;\n}\n\n.tableControls {\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.searchBar, .filters {\n  width: 100%;\n}\n\n.tableWrapper {\n  overflow-x: auto;\n}\n\n.table {\n  min-width: 650px;\n}\n\n.avatar {\n  width: 2rem;\n  height: 2rem;\n}\n\n.userName, .userEmail {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 150px;\n}\n\n.pagination {\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Tablet and desktop adjustments */\n@media (min-width: 768px) {\n  .container {\n    padding: 2rem;\n  }\n  \n  .header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .tableControls {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n  \n  .searchBar {\n    flex: 1;\n    max-width: 60%;\n  }\n  \n  .filters {\n    width: auto;\n    display: flex;\n    gap: 0.75rem;\n  }\n  \n  .pagination {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n  \n  .userName, .userEmail {\n    max-width: 200px;\n  }\n}\n\n.modalWrapper{\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.modalContent {\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 6px 12px rgba(255, 51, 51, 0.5);\n  position: relative;\n  \n}\n.closeButton {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UsersContent_container__e5W7X`,
	"header": `UsersContent_header__Nydro`,
	"title": `UsersContent_title__R-tz4`,
	"subtitle": `UsersContent_subtitle__79goL`,
	"addButton": `UsersContent_addButton__OdV9R`,
	"statsContainer": `UsersContent_statsContainer__nm2J1`,
	"statCard": `UsersContent_statCard__U6bS-`,
	"statIcon": `UsersContent_statIcon__1MMO7`,
	"totalIcon": `UsersContent_totalIcon__IUZ2+`,
	"activeIcon": `UsersContent_activeIcon__Po2oP`,
	"suspendedIcon": `UsersContent_suspendedIcon__+MC3o`,
	"verifiedIcon": `UsersContent_verifiedIcon__PRM8L`,
	"statInfo": `UsersContent_statInfo__GUWui`,
	"statLabel": `UsersContent_statLabel__PV9zJ`,
	"statValue": `UsersContent_statValue__zYc5w`,
	"tableControls": `UsersContent_tableControls__ChlGL`,
	"searchBar": `UsersContent_searchBar__DZN71`,
	"searchInput": `UsersContent_searchInput__00eY5`,
	"filters": `UsersContent_filters__bgOVw`,
	"roleFilter": `UsersContent_roleFilter__fEE6g`,
	"actionSelect": `UsersContent_actionSelect__J4xuS`,
	"tableWrapper": `UsersContent_tableWrapper__EXvZm`,
	"table": `UsersContent_table__wHvCQ`,
	"userColumn": `UsersContent_userColumn__oe0Uu`,
	"userCell": `UsersContent_userCell__1CP-H`,
	"userInfo": `UsersContent_userInfo__0nb8v`,
	"avatar": `UsersContent_avatar__RmcjJ`,
	"userAvatar": `UsersContent_userAvatar__tSgNH`,
	"userDetails": `UsersContent_userDetails__64Yb-`,
	"userName": `UsersContent_userName__taxSa`,
	"userEmail": `UsersContent_userEmail__52vzd`,
	"roleTag": `UsersContent_roleTag__q3hL7`,
	"statusTag": `UsersContent_statusTag__4B72W`,
	"roleAdmin": `UsersContent_roleAdmin__+bc0c`,
	"roleEditor": `UsersContent_roleEditor__L0CaP`,
	"roleUser": `UsersContent_roleUser__LdHz7`,
	"statusActive": `UsersContent_statusActive__3dFB1`,
	"statusSuspended": `UsersContent_statusSuspended__RowS6`,
	"statusPending": `UsersContent_statusPending__u9EID`,
	"actions": `UsersContent_actions__HH4md`,
	"editButton": `UsersContent_editButton__4wsj-`,
	"deleteButton": `UsersContent_deleteButton__nho3+`,
	"pagination": `UsersContent_pagination__qzX0G`,
	"pageInfo": `UsersContent_pageInfo__+Jhcl`,
	"pageControls": `UsersContent_pageControls__oILFr`,
	"pageButton": `UsersContent_pageButton__YFsjE`,
	"activePage": `UsersContent_activePage__Ig9dd`,
	"ellipsis": `UsersContent_ellipsis__B6XRc`,
	"error": `UsersContent_error__oFPYV`,
	"modalWrapper": `UsersContent_modalWrapper__r2Qdg`,
	"modalContent": `UsersContent_modalContent__7OYlX`,
	"closeButton": `UsersContent_closeButton__Emwog`
};
export default ___CSS_LOADER_EXPORT___;
